import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useArrowIdsBySheets = (sheetIds: string[] | undefined) : string[] | undefined => {
  const arrowDb = useSelector((state: RootState) => state.arrowDb);
  if (sheetIds === undefined) return;
  let ids: string[] = [];
  sheetIds.forEach(sheetId => {
    const nominateIds = Object.keys(arrowDb.arrows).filter(id => arrowDb.arrows[id].sheetId === sheetId);
    ids.push(...nominateIds);
  })
  return ids;
}

export default useArrowIdsBySheets;
